import { isVoid } from '@dive/utils-js';

export const selectField = (state, model) => state.userFields[model];

export const selectFieldData = (state, model) => {
    const field = selectField(state, model);

    return isVoid(field.data) ? [] : field.data;
};
